import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import LogoShowcase from "@/pages/LogoShowcase";
import SmsTerms from "@/pages/SmsTerms";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";

function App() {
  return (
    <div className="App dark">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/logos" element={<LogoShowcase />} />
          <Route path="/sms-terms" element={<SmsTerms />} />
          <Route path="/sms-opt-in" element={<SmsTerms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0F172A",
            border: "1px solid #1E293B",
            color: "#F8FAFC",
          },
        }}
      />
    </div>
  );
}

export default App;
